import React, {Component} from 'react';
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {Spinner} from "../Spinner";
import {SubmitButton} from "../buttons/SubmitButton";
import { withTranslation } from 'react-i18next';


export class ReportFilterClass extends Component {
    constructor(props) {
        super(props);

        this.state = {
            agencyClientsAdAccounts: null,
            agencyClientAdAccountSelected: null,
            campaignsDataByAgencyClientAdAccountId: {},
            campaignSelected: null,
            loading: this.props.loading
        };

        this.handleSelectedAgencyClientAdAccountChange = this.handleSelectedAgencyClientAdAccountChange.bind(this);
        this.handleCampaignSelectedChange = this.handleCampaignSelectedChange.bind(this);
        this.handleDoOperation = this.handleDoOperation.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.loading !== prevProps.loading) {
            this.setState({
                loading: this.props.loading
            });
        }
    }

    componentDidMount() {
        this.getAgencyClientsAdAccounts();
    }

    // API

    getCampaignsOfAgencyClientAdAccount(agencyClientAdAccountId) {
        new APIClient(this.getCampaignsOfAgencyClientsAdAccountsURL(agencyClientAdAccountId)).call('GET').then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
            } else if (response.status === 'OK') {
                const campaignsDataByAgencyClientAdAccountId = this.state.campaignsDataByAgencyClientAdAccountId;
                campaignsDataByAgencyClientAdAccountId[agencyClientAdAccountId] = response.data
                campaignsDataByAgencyClientAdAccountId[agencyClientAdAccountId].sort((a, b) => a.name.localeCompare(b.name));

                this.setState({
                    campaignsDataByAgencyClientAdAccountId: campaignsDataByAgencyClientAdAccountId
                })
            }
        });
    }

    getAgencyClientsAdAccounts(){
        new APIClient(this.getAgencyClientsAdAccountsURL()).call('GET').then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
                this.setState({
                    agencyClientsAdAccounts: []
                })
            } else if (response.status === 'OK') {
                const items = response.data;
                items.sort((a, b) => {
                    // First, compare by agency_client_name
                    if (a.agency_client_name !== b.agency_client_name) {
                        return a.agency_client_name.localeCompare(b.agency_client_name);
                    }

                    // If agency_client_name is the same, compare by channel
                    if (a.channel !== b.channel) {
                        return a.channel.localeCompare(b.channel);
                    }

                    // If both agency_client_name and channel are the same, compare by name
                    return a.name.localeCompare(b.name);
                });
                this.setState({
                    agencyClientsAdAccounts: response.data
                })
            }
        });
    }

    handleDoOperation() {
        const {agencyClientAdAccountSelected, campaignSelected} = this.state;

        this.props.doOperation(agencyClientAdAccountSelected, campaignSelected);
    }

    handleSelectedAgencyClientAdAccountChange(event) {
        event.preventDefault();

        const newAgencyClientAdAccount = event.target.value;

        this.setState({
            agencyClientAdAccountSelected: newAgencyClientAdAccount,
            campaignSelected: null
        });

        if(typeof this.state.campaignsDataByAgencyClientAdAccountId[newAgencyClientAdAccount] === "undefined") {
            this.getCampaignsOfAgencyClientAdAccount(newAgencyClientAdAccount);
        }
    }

    handleCampaignSelectedChange(event) {
        event.preventDefault();

        const newCampaignSelected = event.target.value;

        this.setState({
            campaignSelected: newCampaignSelected
        });
    }

    renderAgencyClientAdAccountSelectOptionText(agencyClientAdAccountData) {
        return `${agencyClientAdAccountData['agency_client_name']} - ${agencyClientAdAccountData["channel"]} - ${agencyClientAdAccountData["name"]} (${agencyClientAdAccountData["account_id"]})`;
    }


    renderClientsAndAdAccountsSelect() {
        const { t } = this.props;
        if(this.state.agencyClientsAdAccounts === null)
            return <p>{t('common.loading')}</p>

        return <select name="agencyClientAdAccount" onChange={this.handleSelectedAgencyClientAdAccountChange} required="required" className="form-control">
            <option key={"-"} value={""}>---</option>
            {this.state.agencyClientsAdAccounts.map((option) => <option key={option.id}
                                                                        value={option.id}>{this.renderAgencyClientAdAccountSelectOptionText(option)}</option>)}
        </select>
    }

    renderCampaignsSelect() {
        const { t } = this.props;
        const agencyClientAdAccountId = this.state.agencyClientAdAccountSelected;
        if(this.state.agencyClientAdAccountSelected === null)
            return <p>⬅️ {t('report_filter.select_ad_account_first')}</p>

        if(typeof this.state.campaignsDataByAgencyClientAdAccountId[agencyClientAdAccountId] === "undefined")
            return <p>{t('common.loading')}</p>

        const campaignsData = this.state.campaignsDataByAgencyClientAdAccountId[agencyClientAdAccountId];

        return <select name="campaigns" onChange={this.handleCampaignSelectedChange} required="required"
                       className="form-control">
            <option key={"-"} value={""}>---</option>
            {campaignsData.map((option) => <option key={option.campaign_id}
                                                   value={option.campaign_id}>{option.name}</option>)}
        </select>
    }

    // rendering

    render() {
        const { t } = this.props;
        return (
                <div className="form-group" id="account_selector_group">
                    <div className="form-row align-items-center">
                        <div className="form-col col-sm-5 reportFilter">
                            <label>{t('report_filter.select_client_and_account')}:</label>
                            {this.renderClientsAndAdAccountsSelect()}
                        </div>
                        <div className="form-col col-sm-5 reportFilter">
                            <label>{t('report_filter.campaign')}:</label>
                            {this.renderCampaignsSelect()}
                        </div>
                        <div className="form-col col-sm-2 text-right reportFilterButton">
                            {this.renderSaveButton()}
                        </div>
                    </div>
                </div>
        )
    }

    renderSaveButton() {
        const { t } = this.props;
        if (this.state.loading) {
            return <Spinner color="positive small"/>;
        } else {
            return <SubmitButton onClick={this.handleDoOperation} value={t('report_filter.show')} className={"viewInsightButton"} />;
        }
    }


    // URLS

    getAgencyClientsAdAccountsURL() {
        return `${API_URL}get-agencyclients-adaccounts`
    }

    getCampaignsOfAgencyClientsAdAccountsURL(agencyClientAdAccountId) {
        return `${API_URL}get-agencyclient-adaccount-campaigns/${agencyClientAdAccountId}/`
    }

    getGetReportMarkdownURL(agencyClientAdAccountSelected, campaignSelected) {
        return `${API_URL}reports/${agencyClientAdAccountSelected}/${campaignSelected}`
    }
}

export const ReportFilter = withTranslation()(ReportFilterClass);
export default ReportFilter;
